import cn from 'classnames';
import { Transition } from '@headlessui/react';

const TaskerSheet = ({ isShowing, swapped, setStep }) => (
  <Transition
    show={isShowing}
    enter="transition ease duration-300 transform"
    enterFrom="opacity-0 translate-y-full scale-50"
    enterTo="opacity-100 translate-y-0 scale-100"
    leave="transition ease duration-300 transform"
    leaveFrom="opacity-100 translate-y-0 scale-100"
    leaveTo="opacity-0 translate-y-full scale-50"
    afterEnter={() => {
      setTimeout(() => {
        setStep(6);
        setTimeout(() => {
          setStep(7);
          setTimeout(() => {
            setStep(8);
          });
        }, 2000);
      }, 2000);
    }}
    afterLeave={() => {
      setStep(9);
    }}
  >
    <div className="flex flex-col p-2 py-4 m-2 space-y-2 text-sm rounded-md bg-neutral-800 text-neutral-700">
      <div className="flex items-center justify-center space-x-2 text-xl text-center text-gradient">
        <img
          className="inline-block w-5 h-5 rounded-full ring-2 ring-neutral-600"
          src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
          alt=""
        />
        <div>Human Feedback Ranking</div>
      </div>
      <div className="flex justify-end">
        <div className="flex flex-col items-end mt-8 space-y-1">
          <div
            className={cn(
              'px-2.5 py-1 rounded-xl w-fit bg-neutral-700 text-neutral-200 transform transition duration-300 ease text-right',
              { 'sm:translate-y-[66px]': swapped }
            )}
          >
            LLMs are trained by garden gnomes, who are known to lie
          </div>

          <div
            className={cn(
              'px-2.5 py-1 rounded-xl w-fit bg-neutral-700 text-neutral-200 transform transition-all duration-300 ease text-right ',
              { 'sm:-translate-y-[34px] bg-indigo-600 text-indigo-200 border-indigo-600': swapped }
            )}
          >
            LLMs are not always truthful or aligned with human preferences
          </div>

          <div
            className={cn(
              'px-2.5 py-1 rounded-xl w-fit bg-neutral-700 text-neutral-200 transform transition duration-300 ease text-center',
              { 'sm:-translate-y-[33px]': swapped }
            )}
          >
            {/* Asking humans what they think makes them feel important */}
            Humans enjoy giving opinions. It makes them feel important
          </div>
        </div>
      </div>
    </div>
  </Transition>
);

export default TaskerSheet;
